<div class="text-center col-12 col-md-8 mx-auto my-2 border border-dark rounded">
    <div class="d-flex justify-content-center flex-wrap">
        <img src="assets/images/interac_logo.svg" alt="Interac logo" style="width:10%">
        <div class="text-center fs-28 py-3 border border-dark px-2 bg-secondary text-light rounded"
            style="margin-left:-0.2rem !important">
            eTransfer</div>
        <div class="w-100 d-flex justify-content-left mx-2 py-2 flex-wrap ">
            <span class="w-100 text-left py-1">
                Your money transfer is ready for payment.
                <!-- to <span id="nameOfReciever"></span>. -->
            </span>
            <span class="w-100 text-left py-1">
                N2Xpress uses Interac e-Transfer to complete the payment of your money transfer.
            </span>
            <span class="w-100 text-left py-1">
                Please send ${{ amount }}.
            </span>
            <span class="w-100 text-left">
                To send, follow the easy-to-use instructions: 
            </span>
            <span class="w-100 text-left d-flex flex-wrap fs-14 px-2">
                <span class="w-100">
                    &nbsp;1. &nbsp; Log into your online or mobile banking app and select the
                    account.
                </span>
                <span class="w-100">
                    &nbsp;2. &nbsp;Choose or add <u
                        class="font-weight-bold text-primary">transfers@n2xpress.com.</u>
                </span>
                <span class="w-100">
                    &nbsp;3. &nbsp;Enter the amount of ${{ amount }}.
                </span>
                <span class="w-100">
                    &nbsp;4. &nbsp;In the message field enter
                    <div class="text-left col-12 col-md-8 mx-auto">
                        <input type="text" [(ngModel)]="trans_key" class="w-74 border outline-none  px-2 py-1" readonly
                            id="transactionID">
                        <button (click)="copyMessage()"
                            class="px-0 px-md-3 w-24 text-white border-0 outline-none py-1 copyButton ml-2"
                            data-toggle="tooltip" title="Copy to Clipboard">Copy</button>
                    </div>
                </span>
                <span class="w-100 pt-2">
                    &nbsp;5. &nbsp;<span class="font-weight-bold">
                        VERY IMPORTANT “DO NOT ENTER A SECURITY QUESTION OR ANSWER.”</span><br />
                    <span class="pl-4">
                        (N2Xpress is registered for Interac e-Transfer® Autodeposit)
                    </span> 
                </span>
            </span>
            <span class="w-100 text-left pt-3">
                Interac e-Transfer is available at over 250 participating financial institutions in
                Canada.
            </span>
            <span class="w-100 text-left">
                To find yours click here.
            </span>
            <span class="w-100 text-left pt-3">
                Or select from the following
            </span>
            <span class="w-100 row m-0 justify-content-center">
                <a href="https://www.bmo.com/main/personal" target="_blank"
                    class="col-2 col-md-1 m-1 d-flex align-items-center p-0">
                    <img src="assets/images/b1.jpg" alt="Bank of Montreal logo" class="w-100">
                </a>
                <a href="https://www.cibc.com/en/personal-banking.html" target="_blank"
                    class="col-2 col-md-1 m-1 d-flex align-items-center p-0">
                    <img src="assets/images/b2.png" alt="Canadian Imperial Bank of Commerce logo" class="w-100">
                </a>
                <a href="https://www.td.com/ca/en/personal-banking/" target="_blank"
                    class="col-2 col-md-1 m-1 d-flex align-items-center p-0">
                    <img src="assets/images/b3.png" alt="Toronto-Dominion Bank logo" class="w-100">
                </a>
                <a href="https://www.rbcroyalbank.com/personal.html" target="_blank"
                    class="col-2 col-md-1 m-1 d-flex align-items-center p-0">
                    <img src="assets/images/b4.png" alt="RBC Royal Bank logo" class="w-100">
                </a>
                <a href="https://auth.scotiaonline.scotiabank.com/online" target="_blank"
                    class="col-2 col-md-1 m-1 d-flex align-items-center p-0">
                    <img src="assets/images/b5.png" alt="Scotia Bank logo" class="w-100">
                </a>
            </span>
            <span class="w-100 text-center text-danger pt-3">
                NOTE : This transaction will be valid for 3 working days.
            </span>
        </div>
    </div>

    <!-- MONEY SUCCESS NEWEST DESIGN ENDS -->
</div>